<div class="modal in" id="tutorialModal" tabindex="-1" role="dialog" aria-labelledby="tutorialModalLabel">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header bg-light">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title fs18" id="tutorialModalLabel">Hodxpress'ya Hoşgeldiniz!</h4>
            </div>

            <div class="modal-body">
                <wizard 
                    on-finish="finishedWizard()" 
                    indicators-position="top" 
                    on-cancel="cancelledWizard()" 
                    class="text-center tutorial"> 
                    <wz-step wz-title="Başlangıç">
                        <h2>Hodxpress'ya hoş geldiniz!</h2>
                        <p>Teleskop sistemini anlatan kısa turumuza hemen katılarak hızlı bir başlangıç yapalım.</p>
                        <a href="#" class="btn btn-warning" data-dismiss="modal">Daha Sonra!</a>
                        <a href="#" class="btn btn-success" wz-next >Başlayalım!</a> <br>
                        <a href="#" class="text-center mt15" ng-click="finishTour()">Bir Daha Gösterme!</a>
                    </wz-step>
                    <wz-step wz-title="Çalışan">
                        <h2>Sizin için bir test çalışan oluşturduk.</h2>
                        <p>Oluşturmuş olduğunuz çalışana iş ataması yapıp konum takibi yapabilmeniz için çalışanınızın mobil uygulamamızı indirip aşağıdaki bilgiler ile giriş yapması gerekmektedir.</p>
                        <p>Telefon Numarası : <strong>{{ authenticatedUser.phone_number }}</strong></p>
                        <p>Şifreniz : <strong>Giriş Yaptığınız Şifre</strong></p>
                        <a class="mr10" href="https://apps.apple.com/tr/app/hodxpress/id1492414883" target="_blank">
                            <img src="img/Appstore.png">
                        </a>
                        <a class="mr10" href="https://play.google.com/store/apps/details?id=com.karaja.teleskop&hl=tr" target="_blank">
                            <img src="img/google-play.png" width="180">
                        </a>
                        <br>
                        <a href="#" class="btn btn-success" wz-next>Devam Et!</a>
                    </wz-step>
                    <wz-step wz-title="İş">
                        <h2>Hemen bir iş atayalım.</h2>
                        <p>Hemen bir iş oluşturarak bu personele atama yapalım ve iş akışını görelim.</p>
                        <a href="#" class="btn btn-success" wz-next ng-click="startCreateOrder()">Kargo Oluştur</a>
                    </wz-step>
                    <wz-step wz-title="Firma" class="allcp-form">
                        <h2>Firma bigilerinizi tamamlayın.</h2>
                        <p>Firma bigilerinizi doldurarak Teleskop'u daha çok özelleştirebilirsiniz.</p>
                        <form class="form-horizontal" ng-controller="AccountController" ng-init="init()" ng-submit="updateCompanyInfo()">
                            <div class="form-group">
                                <label for="store-name-5" class="col-md-3 control-label">Şirket Adı:</label>
                                <div class="col-md-9">
                                    <label for="store-name-5" class="field prepend-icon">
                                        <input type="text" name="store-name-5" id="business-name-2" placeholder="Şirket Adı" class="gui-input" ng-model="company.company.name">
                                        <label for="store-name-5" class="field-icon">
                                            <i class="fa fa-link"></i>
                                        </label>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="store-name" class="col-md-3 control-label">Yetkili Adı:</label>
                                <div class="col-md-9">
                                    <label for="store-name" class="field prepend-icon">
                                        <input type="text" name="store-name" id="business-name-3" placeholder="Yetkili Adı" class="gui-input" ng-model="company.user.first_name">
                                        <label for="store-name" class="field-icon">
                                            <i class="fa fa-user"></i>
                                        </label>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="store-name" class="col-md-3 control-label">Yetkili Soyadı:</label>
                                <div class="col-md-9">
                                    <label for="store-name" class="field prepend-icon">
                                        <input type="text" name="store-name" id="business-name-4" placeholder="Yetkili Soyadı" class="gui-input" ng-model="company.user.last_name">
                                        <label for="store-name" class="field-icon">
                                            <i class="fa fa-user"></i>
                                        </label>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="store-phone-2" class="col-md-3 control-label">Telefon:</label>

                                <div class="col-md-9">
                                    <label for="store-phone-2" class="field prepend-icon">
                                        <input type="text" name="store-phone-2" id="store-phone-2" placeholder="Telefon" class="gui-input" ng-model="company.company.phone">
                                        <label for="store-phone-2" class="field-icon">
                                            <i class="fa fa-phone"></i>
                                        </label>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="store-phone-3" class="col-md-3 control-label">Cep Telefon:</label>

                                <div class="col-md-9">
                                    <label for="store-phone-3" class="field prepend-icon">
                                        <input type="text" name="store-phone-3" id="store-phone-3" class="gui-input" placeholder="Cep Telefon" ng-model="company.company.mobile_phone">
                                        <label for="store-phone-3" class="field-icon">
                                            <i class="fa fa-mobile-phone"></i>
                                        </label>
                                    </label>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="store-desc" class="col-md-3 control-label">Adres:</label>
                                <div class="col-md-9">
                                    <label class="field prepend-icon">
                                        <textarea class="gui-textarea" id="store-desc" name="store-desc" ng-model="company.company.address" placeholder="Adres"></textarea>
                                        <label for="store-desc" class="field-icon">
                                            <i class="fa fa-location-arrow"></i>
                                        </label>
                                    </label>
                                </div>
                            </div>
                            <!--
                            <div class="form-group">
                                <div class="col-md-12">
                                    <div id="company-setting-map" style="height:300px;width:100%;"></div>
                                </div>
                            </div>
                            -->
                                        
                            <div class="form-group">
                                <div class="col-md-12">
                                    <div class="pull-right">
                                        <button type="submit" class="btn btn-primary btn-success">Güncelle ve Devam Et</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </wz-step>
                    <wz-step wz-title="Son">
                        <h2>Hepsi Bu Kadar!</h2>
                        <p>Artık teleskop'u kullanmaya başlayabilirsiniz. Teleskop ile hem zamandan kazanın hemde iş ve çalışan verimliliğinizi artırarak işinizi en yükseğe taşıyın!</p>
                        <a href="#" class="btn btn-success" wz-next ng-click="finishTour()">Kullanmaya Başlayın!</a>
                    </wz-step>
                </wizard>
            </div>

        </div>
    </div>
</div>

<tour step="currentStep" ng-if="tour" post-tour="postTourCallback()" tour-complete="tourCompleteCallback()">
    <virtual-step
        tourtip="Bu menüden ihtiyacınız olabilecek tüm işlemlere ulaşabilirsiniz (raporlar, müşteri yönetimi, çalışan yönetimi, ekip yönetimi, yetkilendirme, iş yönetimi, özel formlar, sms gönderme vs)"
        tourtip-placement="right"
        tourtip-step="0"
        tourtip-next-label="Devam Et"
        tourtip-element=".allMenu"></virtual-step>
    <!--
    <virtual-step
        tourtip="Buradan yeni işler oluşturup personellerinize bu işlerin atamalarını yapabilirsiniz."
        tourtip-placement="bottom"
        tourtip-step="1"
        tourtip-next-label="Devam Et"
        tourtip-element="#newOrder"></virtual-step>
    -->
    <virtual-step
        tourtip="Buradaki sekmeden personellerinizin durumlarını, mobil bilgilerini, ellerindeki işleri ve performanslarını takip edebilirsiniz."
        tourtip-placement="left"
        tourtip-step="1"
        tourtip-next-label="Devam Et"      
        tourtip-element="#eRightPanel"></virtual-step>
    <virtual-step
        tourtip="Buradaki sekmeden oluşturduğunuz görevlerin durumlarını takip edebilir ve bu iş surecinde ki tüm ayrıntılara ulaşabilirsiniz."
        tourtip-placement="right"
        tourtip-step="2"
        tourtip-next-label="Devam Et"      
        tourtip-element="#eLeftPanel"></virtual-step>
</tour>
    